import { Injectable } from '@angular/core';
import { environment } from '../../../src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Response_dml_bean,ResponseMensaje } from '../model/response-dml';

@Injectable({
  providedIn: 'root'
})
export class DetArchivoService {

  baseURL = environment.urlBase;
  baseURLFirma = environment.urlBaseFirmado;
  userCons = environment.usuarioConstancias;
  passCons = environment.claveConstancias;

  constructor(private httpclient:HttpClient) {}

  getFile(P_X_ID_OPENKM : string): Observable<Blob> {

    var url  : string;
    url = this.baseURL + 'archivo/api/descargar';

    let params = new HttpParams()
    .set('P_X_ID_OPENKM', P_X_ID_OPENKM);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });


    return this.httpclient.get(url, {headers:headers,params: params,responseType: 'blob'});

  }
  getFilePdf(P_X_ID_OPENKM : string,P_C_CONSTANCIA:string): Observable<Blob> {

    var url  : string;
    url = this.baseURL + 'archivo/api/descargarpdffirma';

    let params = new HttpParams()
    .set('P_X_ID_OPENKM', P_X_ID_OPENKM)
    .set('P_C_CONSTANCIA', P_C_CONSTANCIA);

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });


    return this.httpclient.get(url, {headers:headers,params: params,responseType: 'blob'});

  }
  getRutaArchivoFirma(P_C_CONSTANCIA : string,EXTENSION:string):string
  {
    return this.baseURL+'StaticFiles/generadofirma_'+P_C_CONSTANCIA+EXTENSION;
  }

  upload(formData:FormData): Observable<Response_dml_bean> {

    var url  : string;
    url = this.baseURL + 'archivo/api/subir';


    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });

    return this.httpclient.post<Response_dml_bean>(url,formData,{headers:headers});

  }
  uploadPlantilla(formData:FormData,P_C_CONSTANCIA:string,P_C_PARTICIPANTE:string): Observable<Response_dml_bean> {

    var url  : string;
    url = this.baseURL + 'archivo/api/subirplantilla';

    let params = new HttpParams()
    .set('P_C_CONSTANCIA', P_C_CONSTANCIA)
    .set('P_C_PARTICIPANTE', P_C_PARTICIPANTE);
    //formData.append(id,'22');

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });


    return this.httpclient.post<Response_dml_bean>(url,formData,{headers:headers,params: params});

  }
}
